// @generated drizzle-zero signature:sha256:9eb5636774805d46088487625a110504e10af4a585bb5fd921a54f4b75a97611
// This file was automatically generated by drizzle-zero.
// You should NOT make any changes in this file as it will be overwritten.
import { createBuilder } from "@rocicorp/zero";
const accountTable = {
    "name": "account",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "emailAddress": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "email_address"
        },
        "firebaseId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "firebase_id"
        },
        "verifiedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "verified_at"
        },
        "creationDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "creation_date"
        }
    },
    "primaryKey": ["id"]
};
const agencyTable = {
    "name": "agency",
    "columns": {
        "name": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "mainColor": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "main_color"
        },
        "afmNumber": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "afm_number"
        },
        "emailAddress": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "email_address"
        },
        "website": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "phoneNumber": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "phone_number"
        },
        "hdnNodeKvkNumber": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_node_kvk_number"
        },
        "hdnNodeZipCode": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_node_zip_code"
        },
        "hdnNodeNumberForVerification": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_node_number_for_verification"
        },
        "hdnNodeNumber": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_node_number"
        },
        "financingDefaults": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "financing_defaults"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "creationDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "creation_date"
        },
        "dossierCount": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "dossier_count"
        },
        "conversationCount": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "conversation_count"
        }
    },
    "primaryKey": ["id"]
};
const agencyServiceProviderConnectionTable = {
    "name": "agencyServiceProviderConnection",
    "columns": {
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "serviceProviderId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "service_provider_id"
        },
        "connectionNumber": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "connection_number"
        },
        "connectedBy": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "connected_by"
        },
        "activeSince": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "active_since"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["agencyId", "serviceProviderId"],
    "serverName": "agency_service_provider_connection"
};
const appUserTable = {
    "name": "appUser",
    "columns": {
        "fullName": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "full_name"
        },
        "emailAddress": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "email_address"
        },
        "accountId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "account_id"
        },
        "role": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "agencyId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "agency_id"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "firebaseId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "firebase_id"
        },
        "verifiedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "verified_at"
        },
        "creationDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "creation_date"
        }
    },
    "primaryKey": ["id"],
    "serverName": "app_user"
};
const conversationDetailTable = {
    "name": "conversationDetail",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "conversationId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "conversation_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "transcriptionResult": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "transcription_result"
        }
    },
    "primaryKey": ["id"],
    "serverName": "conversation_detail"
};
const conversationTable = {
    "name": "conversationTable",
    "columns": {
        "title": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "generatedTitle": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "generated_title"
        },
        "displayId": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "display_id"
        },
        "durationInSeconds": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "duration_in_seconds"
        },
        "summary": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "recordingId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "recording_id"
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "createdBy": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "created_by"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "dossierId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "dossier_id"
        }
    },
    "primaryKey": ["id"],
    "serverName": "conversation"
};
const dataRequestTable = {
    "name": "dataRequestTable",
    "columns": {
        "content": {
            "type": "json",
            "optional": true,
            "customType": null
        },
        "dynamicLink": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "dynamic_link"
        },
        "customerId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "customer_id"
        },
        "hdnPersonId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_person_id"
        },
        "hdnDossierId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_dossier_id"
        },
        "dataprovider": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "channel": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "failureReason": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "failure_reason"
        },
        "appliedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "applied_at"
        },
        "appliedBy": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "applied_by"
        },
        "createdBy": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "created_by"
        },
        "parentDataRequestId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "parent_data_request_id"
        },
        "dossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "dossier_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "updated_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "data_request"
};
const dataRequestTokenTable = {
    "name": "dataRequestTokenTable",
    "columns": {
        "dataRequestId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "data_request_id"
        },
        "tokenHash": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "token_hash"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "data_request_token"
};
const dataRequestValidationTable = {
    "name": "dataRequestValidationTable",
    "columns": {
        "hdnMessageId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_message_id"
        },
        "hdnDossierId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_dossier_id"
        },
        "dataRequestId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "data_request_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "sourceType": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "source_type"
        },
        "occurredAt": {
            "type": "number",
            "optional": false,
            "customType": null,
            "serverName": "occurred_at"
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "description": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "specific": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "data_request_validation"
};
const dossierTable = {
    "name": "dossier",
    "columns": {
        "name": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "displayId": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "display_id"
        },
        "creationDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "creation_date"
        },
        "lastOpened": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "last_opened"
        },
        "createdBy": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "created_by"
        },
        "dossierOwner": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "dossier_owner"
        }
    },
    "primaryKey": ["id"]
};
const dossierDocumentTable = {
    "name": "dossierDocument",
    "columns": {
        "filename": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "contentType": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "content_type"
        },
        "byteSize": {
            "type": "number",
            "optional": false,
            "customType": null,
            "serverName": "byte_size"
        },
        "dossierId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "dossier_id"
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "uploadedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "uploaded_at"
        },
        "agencyId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "agency_id"
        },
        "creationDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "creation_date"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "dossier_document"
};
const dossierDocumentClassificationTable = {
    "name": "dossierDocumentClassification",
    "columns": {
        "documentId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "document_id"
        },
        "dossierId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "dossier_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "label": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "confidence": {
            "type": "number",
            "optional": false,
            "customType": null
        },
        "pageCount": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "page_count"
        },
        "classifiedBy": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "classified_by"
        },
        "classifiedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "classified_at"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "dossier_document_classification"
};
const dossierDocumentTokenTable = {
    "name": "dossierDocumentToken",
    "columns": {
        "documentId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "document_id"
        },
        "ownerId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "owner_id"
        },
        "uploadUrl": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "upload_url"
        },
        "creationDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "creation_date"
        },
        "expiresAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "expires_at"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "dossierId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "dossier_id"
        }
    },
    "primaryKey": ["id"],
    "serverName": "dossier_document_token"
};
const dossierUserTable = {
    "name": "dossierUser",
    "columns": {
        "userId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "user_id"
        },
        "dossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "dossier_id"
        }
    },
    "primaryKey": ["userId", "dossierId"],
    "serverName": "dossier_user"
};
const dossierVersionNotesTable = {
    "name": "dossierVersionNotes",
    "columns": {
        "versionId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "version_id"
        },
        "lastChanged": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "last_changed"
        },
        "notes": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "changedBy": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "changed_by"
        }
    },
    "primaryKey": ["versionId"],
    "serverName": "dossier_version_notes"
};
const hdnDossierTable = {
    "name": "hdnDossierTable",
    "columns": {
        "status": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "statusMessage": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "status_message"
        },
        "kind": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "providerCode": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "provider_code"
        },
        "receiverCode": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "receiver_code"
        },
        "serviceProviderId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "service_provider_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "hdnRequestTraceNr": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_request_trace_nr"
        },
        "hdnId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_id"
        },
        "dossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "dossier_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_dossier"
};
const hdnInformatieAanvraagTable = {
    "name": "hdnInformatieAanvraagTable",
    "columns": {
        "content": {
            "type": "json",
            "optional": false,
            "customType": null
        },
        "response": {
            "type": "json",
            "optional": true,
            "customType": null
        },
        "existingMortgageId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "existing_mortgage_id"
        },
        "hdnDossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_dossier_id"
        },
        "dossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "dossier_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_informatie_aanvraag"
};
const hdnLenderConnectionTable = {
    "name": "hdnLenderConnection",
    "columns": {
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "lenderCode": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "lender_code"
        },
        "serviceProviderId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "service_provider_id"
        },
        "connectionNumber": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "connection_number"
        },
        "sendMethod": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "send_method"
        },
        "activeSince": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "active_since"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["agencyId", "lenderCode"],
    "serverName": "hdn_lender_connection"
};
const hdnLoanApplicationTable = {
    "name": "hdnLoanApplication",
    "columns": {
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "kenmerk": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "hdnDossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_dossier_id"
        },
        "dossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "dossier_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_loan_application"
};
const hdnPartijNawDataTable = {
    "name": "hdnPartijNawData",
    "columns": {
        "givenNames": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "given_names"
        },
        "birthInsert": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "birth_insert"
        },
        "birthSurname": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "birth_surname"
        },
        "correspondenceFirstname": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "correspondence_firstname"
        },
        "correspondenceInsert": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "correspondence_insert"
        },
        "correspondenceSurname": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "correspondece_surname"
        },
        "initials": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "birthDate": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "birth_date"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "hdnRef": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_ref"
        },
        "hdnDossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_dossier_id"
        },
        "hdnLoanApplicationId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_loan_application_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_partij_naw_data"
};
const hdnProviderTable = {
    "name": "hdnProvider",
    "columns": {
        "name": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "mortgage": {
            "type": "boolean",
            "optional": true,
            "customType": null
        },
        "insurance": {
            "type": "boolean",
            "optional": true,
            "customType": null
        },
        "credit": {
            "type": "boolean",
            "optional": true,
            "customType": null
        },
        "receiverCode": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "receiver_code"
        },
        "label": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "isActive": {
            "type": "boolean",
            "optional": true,
            "customType": null,
            "serverName": "is_active"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["name"],
    "serverName": "hdn_provider"
};
const hdnProviderProductTable = {
    "name": "hdnProviderProduct",
    "columns": {
        "providerCode": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "provider_code"
        },
        "productCode": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "product_code"
        },
        "isActive": {
            "type": "boolean",
            "optional": true,
            "customType": null,
            "serverName": "is_active"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_provider_product"
};
const hdnProviderProductPartTable = {
    "name": "hdnProviderProductPart",
    "columns": {
        "providerCode": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "provider_code"
        },
        "productPartCode": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "product_part_code"
        },
        "isActive": {
            "type": "boolean",
            "optional": true,
            "customType": null,
            "serverName": "is_active"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_provider_product_part"
};
const hdnReceiverTable = {
    "name": "hdnReceiver",
    "columns": {
        "receiverCode": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "receiver_code"
        },
        "receiverId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "receiver_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_receiver"
};
const hdnReceiverBrondataleverancierTable = {
    "name": "hdnReceiverBrondataleverancier",
    "columns": {
        "receiverId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "receiver_id"
        },
        "brondataleverancier": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "isSupported": {
            "type": "boolean",
            "optional": true,
            "customType": null,
            "serverName": "is_supported"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_receiver_brondataleverancier"
};
const hdnReceiverFeatureTable = {
    "name": "hdnReceiverFeature",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "receiver": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "feature": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "value": {
            "type": "json",
            "optional": true,
            "customType": null
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_receiver_feature"
};
const hdnReceiverNodeTable = {
    "name": "hdnReceiverNode",
    "columns": {
        "receiverCode": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "receiver_code"
        },
        "nodeNumber": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "node_number"
        },
        "type": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_receiver_node"
};
const hdnRequestedDocumentTable = {
    "name": "hdnRequestedDocument",
    "columns": {
        "documentType": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "document_type"
        },
        "documentTypeDescription": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "document_type_description"
        },
        "documentMijNr": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "document_mij_nr"
        },
        "submissionMoment": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "submission_moment"
        },
        "opgevraagdViaBron": {
            "type": "boolean",
            "optional": false,
            "customType": null,
            "serverName": "opgevraagd_via_bron"
        },
        "partijNawDataId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "partij_naw_data_id"
        },
        "linkedDocumentActionId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "linked_document_id"
        },
        "sentDocumentActionId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "sent_document_id"
        },
        "sentDocumentAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "sent_document_at"
        },
        "statusmelding": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "statusmeldingDescription": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "statusmelding_description"
        },
        "statusmeldingDatum": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "statusmelding_datum"
        },
        "documentStatusId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "document_status_id"
        },
        "ketenpartijStatusId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "ketenpartij_status_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "hdnLoanApplicationId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_loan_application_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_requested_document"
};
const hdnRequestedDocumentActionTable = {
    "name": "hdnRequestedDocumentAction",
    "columns": {
        "changedBy": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "changed_by"
        },
        "changedAt": {
            "type": "number",
            "optional": true,
            "customType": null
        },
        "documentId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "user_document_id"
        },
        "actionType": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "action_type"
        },
        "requestedDocumentId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "requested_document_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_requested_document_action"
};
const hdnRequestedDocumentStatusUpdateTable = {
    "name": "hdnRequestedDocumentStatusUpdate",
    "columns": {
        "status": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "description": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "source": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "hdnRequestedDocumentId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_requested_document_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "updatedInMessageId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "updated_in_message_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_requested_document_status_update"
};
const hdnServiceProviderTable = {
    "name": "hdnServiceProvider",
    "columns": {
        "name": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "logo": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "icon": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "nodeNumber": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "node_number"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_service_provider"
};
const hdnServiceProviderToProviderTable = {
    "name": "hdnServiceProviderToProvider",
    "columns": {
        "serviceProviderId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "service_provider_id"
        },
        "providerCode": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "provider_code"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["serviceProviderId", "providerCode"],
    "serverName": "hdn_service_provider_to_provider"
};
const inboundEmailTable = {
    "name": "inboundEmailTable",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "from": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "to": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "subject": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "postmarkData": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "postmark_data"
        },
        "receivedAt": {
            "type": "number",
            "optional": false,
            "customType": null,
            "serverName": "received_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "inbound_email"
};
const interestEmailTable = {
    "name": "interestEmailTable",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "from": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "lenderId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "lender_id"
        },
        "isInterest": {
            "type": "boolean",
            "optional": true,
            "customType": null,
            "serverName": "is_interest"
        },
        "interestSheetLinks": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "interest_sheet_links"
        },
        "interestSheetAttachmentIndices": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "interest_sheet_attachment_indices"
        },
        "subject": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "inboundEmailId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "inbound_email_id"
        },
        "receivedAt": {
            "type": "number",
            "optional": false,
            "customType": null,
            "serverName": "received_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "interest_email"
};
const interestSheetTable = {
    "name": "interestSheet",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "interestEmailId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "interest_email_id"
        },
        "lenderId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "lender_id"
        },
        "documentId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "document_id"
        },
        "sourceType": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "source_type"
        },
        "sourceAttachmentIndex": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "source_attachment_index"
        },
        "sourceUrl": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "source_url"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "interest_sheet"
};
const interestSheetDetailTable = {
    "name": "interestSheetDetail",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "interestSheetId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "interest_sheet_id"
        },
        "analysisModel": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "analysis_model"
        },
        "analysisApiVersion": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "analysis_api_version"
        },
        "analysisResult": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "analysis_result"
        },
        "analyzedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "analyzed_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "interest_sheet_detail"
};
const lenderTable = {
    "name": "lender",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "hdnProviderCode": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "hdn_provider_code"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "logo": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "icon": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "aliases": {
            "type": "json",
            "optional": true,
            "customType": null
        },
        "interestDomains": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "interest_domains"
        },
        "isActive": {
            "type": "boolean",
            "optional": true,
            "customType": null,
            "serverName": "is_active"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"]
};
const loanOfferTable = {
    "name": "loanOfferTable",
    "columns": {
        "type": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "offer_type"
        },
        "passingDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "passing_date"
        },
        "acceptanceDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "acceptance_date"
        },
        "extensionPossible": {
            "type": "boolean",
            "optional": true,
            "customType": null,
            "serverName": "extension_possible"
        },
        "mustReturnSignedCopy": {
            "type": "boolean",
            "optional": true,
            "customType": null,
            "serverName": "must_return_signed_copy"
        },
        "description": {
            "type": "json",
            "optional": true,
            "customType": null
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "loanApplicationId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "loan_application_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "hdn_loan_offer"
};
const offerDocumentTable = {
    "name": "offerDocument",
    "columns": {
        "volgnummer": {
            "type": "number",
            "optional": false,
            "customType": null
        },
        "docSoort": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "doc_soort"
        },
        "docSoortOmschrijving": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "doc_soort_omschrijving"
        },
        "storedDocumentId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "stored_document_id"
        },
        "hdnMessageId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_message_id"
        },
        "hdnLoanApplicationId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_loan_application_id"
        },
        "loanOfferId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "hdn_loan_offer_id"
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "receivedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "received_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["storedDocumentId"],
    "serverName": "hdn_offer_document"
};
const versionTable = {
    "name": "version",
    "columns": {
        "name": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "dossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "dossier_id"
        },
        "lastEdited": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "last_edited"
        },
        "versionData": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "version_data"
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "creationDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "creation_date"
        }
    },
    "primaryKey": ["id"]
};
const versionMutationTable = {
    "name": "versionMutation",
    "columns": {
        "versionId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "version_id"
        },
        "versionData": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "version_data"
        },
        "versionMutation": {
            "type": "json",
            "optional": true,
            "customType": null,
            "serverName": "version_mutation"
        },
        "by": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "mutationDate": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "mutation_date"
        }
    },
    "primaryKey": ["id"],
    "serverName": "version_mutation"
};
const workItemTable = {
    "name": "workItem",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "kind": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "phase": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "title": {
            "type": "string",
            "optional": false,
            "customType": null
        },
        "description": {
            "type": "string",
            "optional": true,
            "customType": null
        },
        "agencyId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "agency_id"
        },
        "dossierId": {
            "type": "string",
            "optional": false,
            "customType": null,
            "serverName": "dossier_id"
        },
        "informatieAanvraagId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "informatie_aanvraag_id"
        },
        "dataRequestId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "data_request_id"
        },
        "loanApplicationId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "loan_application_id"
        },
        "ownerUserId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "owner_user_id"
        },
        "ownerAssignedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "owner_assigned_at"
        },
        "resolvedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "resolved_at"
        },
        "resolvedByUserId": {
            "type": "string",
            "optional": true,
            "customType": null,
            "serverName": "resolved_by_user_id"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "updated_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "work_item"
};
const dossierRelationships = {
    "users": [{ "sourceField": ["id"], "destField": ["dossierId"], "destSchema": "dossierUser", "cardinality": "many" }, { "sourceField": ["userId"], "destField": ["id"], "destSchema": "appUser", "cardinality": "many" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "dossierUser": [{ "sourceField": ["id"], "destField": ["dossierId"], "destSchema": "dossierUser", "cardinality": "many" }],
    "versions": [{ "sourceField": ["id"], "destField": ["dossierId"], "destSchema": "version", "cardinality": "many" }],
    "storedDocuments": [{ "sourceField": ["id"], "destField": ["dossierId"], "destSchema": "dossierDocument", "cardinality": "many" }],
    "loanApplications": [{ "sourceField": ["id"], "destField": ["dossierId"], "destSchema": "hdnLoanApplication", "cardinality": "many" }],
    "dataRequest": [{ "sourceField": ["id"], "destField": ["dossierId"], "destSchema": "dataRequestTable", "cardinality": "many" }],
    "workItems": [{ "sourceField": ["id"], "destField": ["dossierId"], "destSchema": "workItem", "cardinality": "many" }],
    "owner": [{ "sourceField": ["dossierOwner"], "destField": ["id"], "destSchema": "appUser", "cardinality": "one" }],
    "conversations": [{ "sourceField": ["id"], "destField": ["dossierId"], "destSchema": "conversationTable", "cardinality": "many" }]
};
const hdnServiceProviderRelationships = {
    "availableProviders": [{ "sourceField": ["id"], "destField": ["serviceProviderId"], "destSchema": "hdnServiceProviderToProvider", "cardinality": "many" }, { "sourceField": ["providerCode"], "destField": ["name"], "destSchema": "hdnProvider", "cardinality": "many" }],
    "connections": [{ "sourceField": ["id"], "destField": ["serviceProviderId"], "destSchema": "agencyServiceProviderConnection", "cardinality": "many" }],
    "serviceProvidersToProviders": [{ "sourceField": ["id"], "destField": ["serviceProviderId"], "destSchema": "hdnServiceProviderToProvider", "cardinality": "many" }]
};
const hdnProviderRelationships = {
    "supportedServiceProviders": [{ "sourceField": ["name"], "destField": ["providerCode"], "destSchema": "hdnServiceProviderToProvider", "cardinality": "many" }, { "sourceField": ["serviceProviderId"], "destField": ["id"], "destSchema": "hdnServiceProvider", "cardinality": "many" }],
    "hdnReceiver": [{ "sourceField": ["receiverCode"], "destField": ["receiverCode"], "destSchema": "hdnReceiver", "cardinality": "one" }],
    "hdnProducts": [{ "sourceField": ["name"], "destField": ["providerCode"], "destSchema": "hdnProviderProduct", "cardinality": "many" }],
    "hdnPartProducts": [{ "sourceField": ["name"], "destField": ["providerCode"], "destSchema": "hdnProviderProductPart", "cardinality": "many" }],
    "serviceProvidersToProviders": [{ "sourceField": ["name"], "destField": ["providerCode"], "destSchema": "hdnServiceProviderToProvider", "cardinality": "many" }],
    "connections": [{ "sourceField": ["name"], "destField": ["lenderCode"], "destSchema": "hdnLenderConnection", "cardinality": "many" }]
};
const accountRelationships = {
    "appUsers": [{ "sourceField": ["id"], "destField": ["accountId"], "destSchema": "appUser", "cardinality": "many" }]
};
const agencyRelationships = {
    "appUsers": [{ "sourceField": ["id"], "destField": ["agencyId"], "destSchema": "appUser", "cardinality": "many" }],
    "dossiers": [{ "sourceField": ["id"], "destField": ["agencyId"], "destSchema": "dossier", "cardinality": "many" }],
    "documents": [{ "sourceField": ["id"], "destField": ["agencyId"], "destSchema": "dossierDocument", "cardinality": "many" }],
    "hdnLoanApplications": [{ "sourceField": ["id"], "destField": ["agencyId"], "destSchema": "hdnLoanApplication", "cardinality": "many" }],
    "hdnPartijNawData": [{ "sourceField": ["id"], "destField": ["agencyId"], "destSchema": "hdnPartijNawData", "cardinality": "many" }],
    "dataRequest": [{ "sourceField": ["id"], "destField": ["agencyId"], "destSchema": "dataRequestTable", "cardinality": "many" }],
    "dataRequestValidations": [{ "sourceField": ["id"], "destField": ["agencyId"], "destSchema": "dataRequestValidationTable", "cardinality": "many" }],
    "conversations": [{ "sourceField": ["id"], "destField": ["agencyId"], "destSchema": "conversationTable", "cardinality": "many" }],
    "workItems": [{ "sourceField": ["id"], "destField": ["agencyId"], "destSchema": "workItem", "cardinality": "many" }]
};
const agencyServiceProviderConnectionRelationships = {
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "connector": [{ "sourceField": ["connectedBy"], "destField": ["id"], "destSchema": "appUser", "cardinality": "one" }],
    "serviceProvider": [{ "sourceField": ["serviceProviderId"], "destField": ["id"], "destSchema": "hdnServiceProvider", "cardinality": "one" }]
};
const appUserRelationships = {
    "account": [{ "sourceField": ["accountId"], "destField": ["id"], "destSchema": "account", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "dossierUser": [{ "sourceField": ["id"], "destField": ["userId"], "destSchema": "dossierUser", "cardinality": "many" }],
    "conversation": [{ "sourceField": ["id"], "destField": ["createdBy"], "destSchema": "conversationTable", "cardinality": "many" }],
    "documentTokens": [{ "sourceField": ["id"], "destField": ["ownerId"], "destSchema": "dossierDocumentToken", "cardinality": "many" }],
    "createdConnections": [{ "sourceField": ["id"], "destField": ["connectedBy"], "destSchema": "agencyServiceProviderConnection", "cardinality": "many" }],
    "ownedDossiers": [{ "sourceField": ["id"], "destField": ["dossierOwner"], "destSchema": "dossier", "cardinality": "many" }],
    "ownedWorkItems": [{ "sourceField": ["id"], "destField": ["ownerUserId"], "destSchema": "workItem", "cardinality": "many" }],
    "resolvedWorkItems": [{ "sourceField": ["id"], "destField": ["resolvedByUserId"], "destSchema": "workItem", "cardinality": "many" }]
};
const conversationDetailRelationships = {
    "conversation": [{ "sourceField": ["conversationId"], "destField": ["id"], "destSchema": "conversationTable", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }]
};
const conversationTableRelationships = {
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "creator": [{ "sourceField": ["createdBy"], "destField": ["id"], "destSchema": "appUser", "cardinality": "one" }],
    "recording": [{ "sourceField": ["recordingId"], "destField": ["id"], "destSchema": "dossierDocument", "cardinality": "one" }],
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }],
    "detail": [{ "sourceField": ["id"], "destField": ["conversationId"], "destSchema": "conversationDetail", "cardinality": "one" }]
};
const dataRequestTableRelationships = {
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "tokens": [{ "sourceField": ["id"], "destField": ["dataRequestId"], "destSchema": "dataRequestTokenTable", "cardinality": "many" }],
    "validations": [{ "sourceField": ["id"], "destField": ["dataRequestId"], "destSchema": "dataRequestValidationTable", "cardinality": "many" }],
    "workItems": [{ "sourceField": ["id"], "destField": ["dataRequestId"], "destSchema": "workItem", "cardinality": "many" }],
    "parent": [{ "sourceField": ["parentDataRequestId"], "destField": ["id"], "destSchema": "dataRequestTable", "cardinality": "one" }],
    "children": [{ "sourceField": ["id"], "destField": ["parentDataRequestId"], "destSchema": "dataRequestTable", "cardinality": "many" }]
};
const dataRequestTokenTableRelationships = {
    "dataRequest": [{ "sourceField": ["dataRequestId"], "destField": ["id"], "destSchema": "dataRequestTable", "cardinality": "one" }]
};
const dataRequestValidationTableRelationships = {
    "dataRequest": [{ "sourceField": ["dataRequestId"], "destField": ["id"], "destSchema": "dataRequestTable", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }]
};
const dossierDocumentClassificationRelationships = {
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }],
    "storedDocument": [{ "sourceField": ["documentId"], "destField": ["id"], "destSchema": "dossierDocument", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }]
};
const dossierDocumentTokenRelationships = {
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "dossierDocument": [{ "sourceField": ["documentId"], "destField": ["id"], "destSchema": "dossierDocument", "cardinality": "one" }],
    "owner": [{ "sourceField": ["ownerId"], "destField": ["id"], "destSchema": "appUser", "cardinality": "one" }]
};
const dossierUserRelationships = {
    "appUser": [{ "sourceField": ["userId"], "destField": ["id"], "destSchema": "appUser", "cardinality": "one" }],
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }]
};
const dossierVersionNotesRelationships = {
    "version": [{ "sourceField": ["versionId"], "destField": ["id"], "destSchema": "version", "cardinality": "one" }],
    "editor": [{ "sourceField": ["changedBy"], "destField": ["id"], "destSchema": "appUser", "cardinality": "one" }]
};
const hdnDossierTableRelationships = {
    "loanApplication": [{ "sourceField": ["id"], "destField": ["hdnDossierId"], "destSchema": "hdnLoanApplication", "cardinality": "one" }],
    "informatieAanvraag": [{ "sourceField": ["id"], "destField": ["hdnDossierId"], "destSchema": "hdnInformatieAanvraagTable", "cardinality": "one" }],
    "hdnReceiver": [{ "sourceField": ["receiverCode"], "destField": ["receiverCode"], "destSchema": "hdnReceiver", "cardinality": "one" }],
    "dataRequest": [{ "sourceField": ["id"], "destField": ["hdnDossierId"], "destSchema": "dataRequestTable", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "serviceProvider": [{ "sourceField": ["serviceProviderId"], "destField": ["id"], "destSchema": "hdnServiceProvider", "cardinality": "one" }],
    "provider": [{ "sourceField": ["providerCode"], "destField": ["name"], "destSchema": "hdnProvider", "cardinality": "one" }]
};
const hdnInformatieAanvraagTableRelationships = {
    "hdnDossier": [{ "sourceField": ["hdnDossierId"], "destField": ["id"], "destSchema": "hdnDossierTable", "cardinality": "one" }],
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "workItems": [{ "sourceField": ["id"], "destField": ["informatieAanvraagId"], "destSchema": "workItem", "cardinality": "many" }]
};
const hdnLenderConnectionRelationships = {
    "lender": [{ "sourceField": ["lenderCode"], "destField": ["name"], "destSchema": "hdnProvider", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "serviceProvider": [{ "sourceField": ["serviceProviderId"], "destField": ["id"], "destSchema": "hdnServiceProvider", "cardinality": "one" }]
};
const hdnLoanApplicationRelationships = {
    "requestedDocuments": [{ "sourceField": ["id"], "destField": ["hdnLoanApplicationId"], "destSchema": "hdnRequestedDocument", "cardinality": "many" }],
    "workItems": [{ "sourceField": ["id"], "destField": ["loanApplicationId"], "destSchema": "workItem", "cardinality": "many" }],
    "hdnDossier": [{ "sourceField": ["hdnDossierId"], "destField": ["id"], "destSchema": "hdnDossierTable", "cardinality": "one" }],
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "loanOffers": [{ "sourceField": ["id"], "destField": ["loanApplicationId"], "destSchema": "loanOfferTable", "cardinality": "many" }]
};
const hdnPartijNawDataRelationships = {
    "hdnDossier": [{ "sourceField": ["hdnDossierId"], "destField": ["id"], "destSchema": "hdnDossierTable", "cardinality": "one" }],
    "loanApplication": [{ "sourceField": ["hdnLoanApplicationId"], "destField": ["id"], "destSchema": "hdnLoanApplication", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "requestedDocuments": [{ "sourceField": ["id"], "destField": ["partijNawDataId"], "destSchema": "hdnRequestedDocument", "cardinality": "many" }]
};
const hdnProviderProductPartRelationships = {
    "hdnProvider": [{ "sourceField": ["providerCode"], "destField": ["name"], "destSchema": "hdnProvider", "cardinality": "one" }]
};
const hdnProviderProductRelationships = {
    "hdnProvider": [{ "sourceField": ["providerCode"], "destField": ["name"], "destSchema": "hdnProvider", "cardinality": "one" }]
};
const hdnReceiverBrondataleverancierRelationships = {
    "hdnReceiver": [{ "sourceField": ["receiverId"], "destField": ["receiverId"], "destSchema": "hdnReceiver", "cardinality": "one" }]
};
const hdnReceiverFeatureRelationships = {
    "hdnReceiver": [{ "sourceField": ["receiver"], "destField": ["receiverId"], "destSchema": "hdnReceiver", "cardinality": "one" }]
};
const hdnReceiverNodeRelationships = {
    "receiver": [{ "sourceField": ["receiverCode"], "destField": ["receiverCode"], "destSchema": "hdnReceiver", "cardinality": "one" }]
};
const hdnReceiverRelationships = {
    "hdnReceiverNode": [{ "sourceField": ["receiverCode"], "destField": ["receiverCode"], "destSchema": "hdnReceiverNode", "cardinality": "many" }],
    "hdnProvider": [{ "sourceField": ["receiverCode"], "destField": ["receiverCode"], "destSchema": "hdnProvider", "cardinality": "many" }],
    "hdnReceiverBrondataleverancier": [{ "sourceField": ["receiverId"], "destField": ["receiverId"], "destSchema": "hdnReceiverBrondataleverancier", "cardinality": "many" }],
    "hdnReceiverFeature": [{ "sourceField": ["receiverId"], "destField": ["receiver"], "destSchema": "hdnReceiverFeature", "cardinality": "many" }]
};
const hdnRequestedDocumentActionRelationships = {
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "requestedDocument": [{ "sourceField": ["requestedDocumentId"], "destField": ["id"], "destSchema": "hdnRequestedDocument", "cardinality": "one" }],
    "document": [{ "sourceField": ["documentId"], "destField": ["id"], "destSchema": "dossierDocument", "cardinality": "one" }]
};
const hdnRequestedDocumentRelationships = {
    "linkedDocumentAction": [{ "sourceField": ["linkedDocumentActionId"], "destField": ["id"], "destSchema": "hdnRequestedDocumentAction", "cardinality": "one" }],
    "sentDocumentAction": [{ "sourceField": ["sentDocumentActionId"], "destField": ["id"], "destSchema": "hdnRequestedDocumentAction", "cardinality": "one" }],
    "documentStatus": [{ "sourceField": ["documentStatusId"], "destField": ["id"], "destSchema": "hdnRequestedDocumentStatusUpdate", "cardinality": "one" }],
    "ketenpartijStatus": [{ "sourceField": ["ketenpartijStatusId"], "destField": ["id"], "destSchema": "hdnRequestedDocumentStatusUpdate", "cardinality": "one" }],
    "partijNawData": [{ "sourceField": ["partijNawDataId"], "destField": ["id"], "destSchema": "hdnPartijNawData", "cardinality": "one" }],
    "updates": [{ "sourceField": ["documentStatusId"], "destField": ["id"], "destSchema": "hdnRequestedDocumentStatusUpdate", "cardinality": "many" }],
    "actions": [{ "sourceField": ["id"], "destField": ["requestedDocumentId"], "destSchema": "hdnRequestedDocumentAction", "cardinality": "many" }],
    "loanApplication": [{ "sourceField": ["hdnLoanApplicationId"], "destField": ["id"], "destSchema": "hdnLoanApplication", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }]
};
const hdnRequestedDocumentStatusUpdateRelationships = {
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "requestedDocument": [{ "sourceField": ["hdnRequestedDocumentId"], "destField": ["id"], "destSchema": "hdnRequestedDocument", "cardinality": "one" }]
};
const hdnServiceProviderToProviderRelationships = {
    "serviceProvider": [{ "sourceField": ["serviceProviderId"], "destField": ["id"], "destSchema": "hdnServiceProvider", "cardinality": "one" }],
    "provider": [{ "sourceField": ["providerCode"], "destField": ["name"], "destSchema": "hdnProvider", "cardinality": "one" }]
};
const inboundEmailTableRelationships = {
    "interestEmail": [{ "sourceField": ["id"], "destField": ["inboundEmailId"], "destSchema": "interestEmailTable", "cardinality": "one" }]
};
const interestEmailTableRelationships = {
    "inboundEmail": [{ "sourceField": ["inboundEmailId"], "destField": ["id"], "destSchema": "inboundEmailTable", "cardinality": "one" }],
    "lender": [{ "sourceField": ["lenderId"], "destField": ["id"], "destSchema": "lender", "cardinality": "one" }],
    "interestSheets": [{ "sourceField": ["id"], "destField": ["interestEmailId"], "destSchema": "interestSheet", "cardinality": "many" }]
};
const interestSheetDetailRelationships = {
    "interestSheet": [{ "sourceField": ["interestSheetId"], "destField": ["id"], "destSchema": "interestSheet", "cardinality": "one" }]
};
const interestSheetRelationships = {
    "interestEmail": [{ "sourceField": ["interestEmailId"], "destField": ["id"], "destSchema": "interestEmailTable", "cardinality": "one" }],
    "lender": [{ "sourceField": ["lenderId"], "destField": ["id"], "destSchema": "lender", "cardinality": "one" }],
    "document": [{ "sourceField": ["documentId"], "destField": ["id"], "destSchema": "dossierDocument", "cardinality": "one" }],
    "detail": [{ "sourceField": ["id"], "destField": ["interestSheetId"], "destSchema": "interestSheetDetail", "cardinality": "one" }]
};
const lenderRelationships = {
    "hdnProvider": [{ "sourceField": ["hdnProviderCode"], "destField": ["name"], "destSchema": "hdnProvider", "cardinality": "one" }]
};
const offerDocumentRelationships = {
    "storedDocument": [{ "sourceField": ["storedDocumentId"], "destField": ["id"], "destSchema": "dossierDocument", "cardinality": "one" }],
    "loanOffer": [{ "sourceField": ["loanOfferId"], "destField": ["id"], "destSchema": "loanOfferTable", "cardinality": "one" }],
    "loanApplication": [{ "sourceField": ["hdnLoanApplicationId"], "destField": ["id"], "destSchema": "hdnLoanApplication", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }]
};
const loanOfferTableRelationships = {
    "application": [{ "sourceField": ["loanApplicationId"], "destField": ["id"], "destSchema": "hdnLoanApplication", "cardinality": "one" }],
    "documents": [{ "sourceField": ["id"], "destField": ["loanOfferId"], "destSchema": "offerDocument", "cardinality": "many" }]
};
const dossierDocumentRelationships = {
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }],
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "conversation": [{ "sourceField": ["id"], "destField": ["recordingId"], "destSchema": "conversationTable", "cardinality": "one" }],
    "classification": [{ "sourceField": ["id"], "destField": ["documentId"], "destSchema": "dossierDocumentClassification", "cardinality": "many" }]
};
const versionMutationRelationships = {
    "version": [{ "sourceField": ["versionId"], "destField": ["id"], "destSchema": "version", "cardinality": "one" }]
};
const versionRelationships = {
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }],
    "dossierVersionNotes": [{ "sourceField": ["id"], "destField": ["versionId"], "destSchema": "dossierVersionNotes", "cardinality": "one" }],
    "mutations": [{ "sourceField": ["id"], "destField": ["versionId"], "destSchema": "versionMutation", "cardinality": "many" }]
};
const workItemRelationships = {
    "agency": [{ "sourceField": ["agencyId"], "destField": ["id"], "destSchema": "agency", "cardinality": "one" }],
    "dossier": [{ "sourceField": ["dossierId"], "destField": ["id"], "destSchema": "dossier", "cardinality": "one" }],
    "informatieAanvraag": [{ "sourceField": ["informatieAanvraagId"], "destField": ["id"], "destSchema": "hdnInformatieAanvraagTable", "cardinality": "one" }],
    "dataRequest": [{ "sourceField": ["dataRequestId"], "destField": ["id"], "destSchema": "dataRequestTable", "cardinality": "one" }],
    "loanApplication": [{ "sourceField": ["loanApplicationId"], "destField": ["id"], "destSchema": "hdnLoanApplication", "cardinality": "one" }],
    "owner": [{ "sourceField": ["ownerUserId"], "destField": ["id"], "destSchema": "appUser", "cardinality": "one" }],
    "resolvedBy": [{ "sourceField": ["resolvedByUserId"], "destField": ["id"], "destSchema": "appUser", "cardinality": "one" }]
};
/**
 * The Zero schema object.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const schema = {
    "tables": {
        "account": accountTable,
        "agency": agencyTable,
        "agencyServiceProviderConnection": agencyServiceProviderConnectionTable,
        "appUser": appUserTable,
        "conversationDetail": conversationDetailTable,
        "conversationTable": conversationTable,
        "dataRequestTable": dataRequestTable,
        "dataRequestTokenTable": dataRequestTokenTable,
        "dataRequestValidationTable": dataRequestValidationTable,
        "dossier": dossierTable,
        "dossierDocument": dossierDocumentTable,
        "dossierDocumentClassification": dossierDocumentClassificationTable,
        "dossierDocumentToken": dossierDocumentTokenTable,
        "dossierUser": dossierUserTable,
        "dossierVersionNotes": dossierVersionNotesTable,
        "hdnDossierTable": hdnDossierTable,
        "hdnInformatieAanvraagTable": hdnInformatieAanvraagTable,
        "hdnLenderConnection": hdnLenderConnectionTable,
        "hdnLoanApplication": hdnLoanApplicationTable,
        "hdnPartijNawData": hdnPartijNawDataTable,
        "hdnProvider": hdnProviderTable,
        "hdnProviderProduct": hdnProviderProductTable,
        "hdnProviderProductPart": hdnProviderProductPartTable,
        "hdnReceiver": hdnReceiverTable,
        "hdnReceiverBrondataleverancier": hdnReceiverBrondataleverancierTable,
        "hdnReceiverFeature": hdnReceiverFeatureTable,
        "hdnReceiverNode": hdnReceiverNodeTable,
        "hdnRequestedDocument": hdnRequestedDocumentTable,
        "hdnRequestedDocumentAction": hdnRequestedDocumentActionTable,
        "hdnRequestedDocumentStatusUpdate": hdnRequestedDocumentStatusUpdateTable,
        "hdnServiceProvider": hdnServiceProviderTable,
        "hdnServiceProviderToProvider": hdnServiceProviderToProviderTable,
        "inboundEmailTable": inboundEmailTable,
        "interestEmailTable": interestEmailTable,
        "interestSheet": interestSheetTable,
        "interestSheetDetail": interestSheetDetailTable,
        "lender": lenderTable,
        "loanOfferTable": loanOfferTable,
        "offerDocument": offerDocumentTable,
        "version": versionTable,
        "versionMutation": versionMutationTable,
        "workItem": workItemTable
    },
    "relationships": {
        "dossier": dossierRelationships,
        "hdnServiceProvider": hdnServiceProviderRelationships,
        "hdnProvider": hdnProviderRelationships,
        "account": accountRelationships,
        "agency": agencyRelationships,
        "agencyServiceProviderConnection": agencyServiceProviderConnectionRelationships,
        "appUser": appUserRelationships,
        "conversationDetail": conversationDetailRelationships,
        "conversationTable": conversationTableRelationships,
        "dataRequestTable": dataRequestTableRelationships,
        "dataRequestTokenTable": dataRequestTokenTableRelationships,
        "dataRequestValidationTable": dataRequestValidationTableRelationships,
        "dossierDocumentClassification": dossierDocumentClassificationRelationships,
        "dossierDocumentToken": dossierDocumentTokenRelationships,
        "dossierUser": dossierUserRelationships,
        "dossierVersionNotes": dossierVersionNotesRelationships,
        "hdnDossierTable": hdnDossierTableRelationships,
        "hdnInformatieAanvraagTable": hdnInformatieAanvraagTableRelationships,
        "hdnLenderConnection": hdnLenderConnectionRelationships,
        "hdnLoanApplication": hdnLoanApplicationRelationships,
        "hdnPartijNawData": hdnPartijNawDataRelationships,
        "hdnProviderProductPart": hdnProviderProductPartRelationships,
        "hdnProviderProduct": hdnProviderProductRelationships,
        "hdnReceiverBrondataleverancier": hdnReceiverBrondataleverancierRelationships,
        "hdnReceiverFeature": hdnReceiverFeatureRelationships,
        "hdnReceiverNode": hdnReceiverNodeRelationships,
        "hdnReceiver": hdnReceiverRelationships,
        "hdnRequestedDocumentAction": hdnRequestedDocumentActionRelationships,
        "hdnRequestedDocument": hdnRequestedDocumentRelationships,
        "hdnRequestedDocumentStatusUpdate": hdnRequestedDocumentStatusUpdateRelationships,
        "hdnServiceProviderToProvider": hdnServiceProviderToProviderRelationships,
        "inboundEmailTable": inboundEmailTableRelationships,
        "interestEmailTable": interestEmailTableRelationships,
        "interestSheetDetail": interestSheetDetailRelationships,
        "interestSheet": interestSheetRelationships,
        "lender": lenderRelationships,
        "offerDocument": offerDocumentRelationships,
        "loanOfferTable": loanOfferTableRelationships,
        "dossierDocument": dossierDocumentRelationships,
        "versionMutation": versionMutationRelationships,
        "version": versionRelationships,
        "workItem": workItemRelationships
    },
    "enableLegacyQueries": false,
    "enableLegacyMutators": false
};
/**
 * Represents the ZQL query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const zql = createBuilder(schema);
/**
 * Represents the Zero schema query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const builder = zql;
